<template>
  <div class="container">
    <el-row :gutter="10">
      <el-col :span="12">
        <!-- 装卸费 -->
        <el-form :model="handlingtForm" ref="handlingFormRef" label-width="30px">
          <el-row>
            <el-col :span="24" class="titleBottom">
              <el-checkbox v-model="handlingtForm.isHanding" true-label="1" false-label="0">装卸费</el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="22">
              <vxe-table
                row-id="handingId"
                size="small"
                ref="xTable"
                resizable
                border
                
                keep-source
                :data="handlingtForm.tableData"
                @edit-closed="saveEvent"
                :edit-config="{trigger: 'click', mode: 'cell', activeMethod: activeCellMethod}"
              >
                <vxe-table-column
                  field="price"
                  title="装卸费"
                  :edit-render="{name: 'input',autoselect: true}"
                ></vxe-table-column>
                <vxe-table-column
                  field="unit"
                  title="单位"
                  :edit-render="{name: 'input',autoselect: true}"
                ></vxe-table-column>
              </vxe-table>
            </el-col>
          </el-row>
        </el-form>
      </el-col>

      <el-col :span="12">
        <!-- 加急费 -->
        <el-form :model="UrgentForm" ref="UrgentFormRef" label-width="0" :rules="urgentRules">
                    <el-row :gutter="10">
            <el-col :span="3" class="titleBottom">
              <el-checkbox v-model="UrgentForm.isUrgent" true-label="1" false-label="0">加急费</el-checkbox>
            </el-col>

            <el-col :span="10">
              <el-form-item label-width="0">
                <el-input placeholder="运费" />
              </el-form-item>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i class="el-icon-close"></i>
            </el-col>
            <el-col :span="10">
              <el-form-item label-width="0"  prop="points">
                <el-input v-model.number="UrgentForm.points" type="number" min="0.00" step="0.01">
                  <i slot="suffix">%</i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

         <!-- 制冷费-->
    <el-form :model="RefrigerationFeeForm" ref="RefrigerationFeeRef" label-width="0">
      <el-row :gutter="10">
        <el-col :span="3" class="titleBottom">
          <el-checkbox
            v-model="RefrigerationFeeForm.isRefrigeration"
            true-label="1"
            false-label="0"
          >制冷费</el-checkbox>
        </el-col>
        <el-col :span="10">
          <el-form-item label-width="0">
            <el-input placeholder="运费" />
          </el-form-item>
        </el-col>
        <el-col :span="1" class="iconCount">
          <i class="el-icon-close"></i>
        </el-col>
        <el-col :span="10">
          <el-form-item label-width="0">
            <el-input
              v-model.number="RefrigerationFeeForm.points"
              type="number"
              min="0.00"
              step="0.01"
            >
              <i slot="suffix">%</i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

        <!-- 信息费 -->
        <el-form :model="messageForm" ref="messageFormRef" label-width="0" :disabled="isMessage">
          <el-row>
            <el-col :span="24" class="titleBottom">
              <el-checkbox v-model="messageForm.isInfo" true-label="1" false-label="0">
                信息费
                <span class="tipsStyle">&nbsp;&nbsp;(若两项都填，则以第一个数值为准)</span>
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label-width="0" prop="price">
                <el-input
                  placeholder="金额"
                  v-model.number="messageForm.price"
                  type="number"
                  min="0.00"
                  step="0.01"
                />
              </el-form-item>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i style="padding-left:10px;" class="orStyle">或</i>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="0" prop="points">
                <el-input v-model.number="messageForm.points" type="number" min="0.00" step="0.01">
                  <i slot="suffix">%</i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 代收款手续费 -->
        <el-form :model="serviceForm" ref="serviceFormRef" label-width="0" :disabled="isService">
          <el-row>
            <el-col :span="3" class="titleBottom">
              <el-checkbox v-model="serviceForm.isProcedure" true-label="1" false-label="0">
                代收款手续费
                <span class="tipsStyle">&nbsp;&nbsp;(若两项都填，则以第一个数值为准)</span>
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label-width="0" prop="price">
                <el-input
                  placeholder="金额"
                  v-model.number="serviceForm.price"
                  type="number"
                  min="0.00"
                  step="0.01"
                />
              </el-form-item>
            </el-col>
            <el-col :span="1" class="iconCount">
              <i style="padding-left:10px;" class="orStyle">或</i>
            </el-col>
            <el-col :span="11">
              <el-form-item label-width="0" prop="points" >
                <el-input v-model.number="serviceForm.points" type="number" min="0.00" step="0.01">
                  <i slot="suffix">%</i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!--      &lt;!&ndash; 高速费、停车费&ndash;&gt;-->
          <!--      <el-form v-model="HighSpeedFeeForm" ref="HighSpeedFeeRef" label-width="0">-->
          <!--        <el-row>-->
          <!--          <el-col :span="24" class="titleBottom">-->
          <!--            <el-checkbox v-model="HighSpeedFeeForm.isHighSpeedFee" true-label="1" false-label="0" >高速费、停车费</el-checkbox>-->
          <!--          </el-col>-->
          <!--        </el-row>-->
          <!--      </el-form>-->
          <!--      &lt;!&ndash; 过路费、过桥费&ndash;&gt;-->
          <!--      <el-form v-model="RollTollFeeForm" ref="RollTollFeeRef" label-width="0">-->
          <!--        <el-row>-->
          <!--          <el-col :span="24" class="titleBottom">-->
          <!--            <el-checkbox v-model="RollTollFeeForm.isRollTollFee" true-label="1" false-label="0" >过路费、过桥费</el-checkbox>-->
          <!--          </el-col>-->
          <!--        </el-row>-->
          <!--      </el-form>-->
          <!--      &lt;!&ndash; 进仓费&ndash;&gt;-->
          <!--      <el-form v-model="WarehousingFeeForm" ref="WarehousingFeeRef" label-width="0">-->
          <!--        <el-row>-->
          <!--          <el-col :span="24" class="titleBottom">-->
          <!--            <el-checkbox v-model="WarehousingFeeForm.isWarehousingFee" true-label="1" false-label="0" >进仓费</el-checkbox>-->
          <!--          </el-col>-->
          <!--        </el-row>-->
          <!--      </el-form>-->
        </el-form>
      </el-col>
    </el-row>






    <!-- 等候费-->
    <el-form :model="WaitFeeForm" ref="WaitFeeFormRef" label-width="0">
      <el-row>
        <el-col :span="24" class="titleBottom">
          <el-checkbox v-model="WaitFeeForm.isWaitFee" true-label="1" false-label="0">等待费</el-checkbox>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="11">
          <el-form-item label="等候时长" label-width="80px" prop="price">
            <el-input v-model.number="WaitFeeForm.price" type="number" min="0.00" step="0.01">
              <i slot="suffix">min</i>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="每" label-width="25px" prop="limitEnd">
            <el-input v-model.number="WaitFeeForm.limitEnd" type="number" min="0.00" step="0.01">
              <i slot="suffix">min</i>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="1" class="iconCount margintop">
          <i class="el-icon-plus"></i>
        </el-col>
        <el-col :span="6" >
          <el-form-item label-width="0" prop="unitPrice">
            <el-input v-model.number="WaitFeeForm.unitPrice" type="number" min="0.00" step="0.01">
              <i slot="suffix">元</i>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

     <el-form v-model="otherFeeForm" ref="WaitFeeRef" label-width="0">
      <el-row>
        <el-col :span="12" class="titleBottom">
          <!--            <el-checkbox v-model="otherFeeForm.isWaitFee" true-label="1" false-label="0" >等候费</el-checkbox>-->
          <el-checkbox v-model="otherFeeForm.isHighSpeedFee" true-label="1" false-label="0">高速费</el-checkbox>
          <el-checkbox v-model="otherFeeForm.isParkingFee" true-label="1" false-label="0">停车费</el-checkbox>
          <el-checkbox v-model="otherFeeForm.isRollTollFee" true-label="1" false-label="0">过路费、过桥费</el-checkbox>
          <el-checkbox v-model="otherFeeForm.isWarehousingFee" true-label="1" false-label="0">进仓费</el-checkbox>
        </el-col>
      </el-row>
    </el-form>


    <!-- 综合最大值 -->
    <el-row>
      <el-col :span="24" class="titleBottom">
        <el-checkbox v-model="handlingtForm.isTotal" true-label="1" false-label="0">综合最大值</el-checkbox>
      </el-col>
    </el-row>
    <!--  <div class="leftBox">

    </div>
    -->
    <!--  <div class="rightBox">

    </div>-->
  </div>
</template>

<script>
export default {
  name: "Handling",
  data() {
    return {
      isService: false,
      isMessage: false,
      WaitFeeForm: {
        isWaitFee: 0,
        price: 60,
        limitEnd: 15,
        unitPrice: 10
      },
      otherFeeForm: {
        isHighSpeedFee: 0,
        isParkingFee:0,
        isRollTollFee: 0,
        isWarehousingFee: 0
      },
      //   HighSpeedFeeForm:{
      //       isHighSpeedFee:0
      // },
      //   RollTollFeeForm:{
      //       isRollTollFee:0
      // },
      //   WarehousingFeeForm:{
      //       isWarehousingFee:0
      // },
      RefrigerationFeeForm: {
        isRefrigeration: 0,
        points: "25"
      },
      UrgentForm: {
        isUrgent: 0,
        isTotal: 0,
        points: ""
      },
      urgentRules: {
         points: [{ type: "number", message: "百分比必须为数字值"  }]
      },
      handlingtForm: {
        isTotal: 0,
        isHanding: 0,
        tableData: [
          { price: 1000, unit: "车", value: "4" },
          { price: 100, unit: "千克", value: "0" },
          { price: 10, unit: "方", value: "3" },
          { price: 1, unit: "件", value: "1" },
          { price: 0.1, unit: "点", value: "2" }
        ]
      },
      messageForm: {
        isInfo: 0,
        price: "",
        points: ""
      },
      serviceForm: {
        isProcedure: 0,
        price: "",
        points: ""
      },
      rules: {
        points: [
          { type: "number", message: "百分比必须为数字值", trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  methods: {
    saveEvent({ row, column }, event) {
    },
    activeCellMethod({ column, columnIndex }) {
      if (columnIndex === 1) {
        return false;
      }
      return true;
    },
    resetAllForm () {
      this.handlingtForm.tableData =  [
          { price: 1000, unit: "车", value: "4" },
          { price: 100, unit: "千克", value: "0" },
          { price: 10, unit: "方", value: "3" },
          { price: 1, unit: "件", value: "1" },
          { price: 0.1, unit: "点", value: "2" }
        ]

      this.$refs.UrgentFormRef.resetFields()
      this.$refs.messageFormRef.resetFields()
      this.$refs.serviceFormRef.resetFields()
      this.$refs.WaitFeeFormRef.resetFields()

      this.otherFeeForm.isHighSpeedFee = 0
      this.otherFeeForm.isParkingFee = 0
      this.otherFeeForm.isRollTollFee = 0
      this.otherFeeForm.isWarehousingFee = 0

      this.RefrigerationFeeForm.isRefrigeration = 0

      this.UrgentForm.isUrgent = 0

      this.handlingtForm.isTotal = 0
      this.handlingtForm.isHanding = 0
      this.messageForm.isInfo = 0
      this.serviceForm.isProcedure = 0
      this.WaitFeeForm.isWaitFee = 0




    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 20px;
}
.title {
  font-weight: 700;
}
.rowBorder {
  margin-bottom: 20px;
  background: rgba(172, 217, 248, 0.2);
}
.conputedStyle {
  margin-top: 60px;
}

.iconCount {
  padding-top: 10px;
  text-align: center;
}
.addBtn {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 3;
}
.inputTable {
  margin: 0;
}
.remove {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  z-index: 3;
}
.titleBottom {
  // margin-bottom: 10px;
  height:36px;
  line-height: 36px;
}
.orStyle {
  font-size: 13px;
  color: #606266;
  font-style: normal;
}
.tipsStyle {
  color: #b1adad;
  font-size: 12px;
}
</style>
